import { ca } from '@cian/analytics';
import { FOfferType } from 'shared/common/packages/JsonQuery';

export function trackShowBanner(offerType: FOfferType) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'MapScreen',
    action: 'Show_sopr',
    label: 'CpdBanner',
    page: {
      cpdOfferType: offerType,
      cpdDealType: 'buy',
    },
  });
}

export function trackClickBanner(offerType: FOfferType) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'MapScreen',
    action: 'Click',
    label: 'CpdBanner',
    page: {
      cpdOfferType: offerType,
      cpdDealType: 'buy',
    },
  });
}
